import { Chat as GenericChat } from '@components'
import { useChannel } from '@features/chat/state'
import { useParams } from '@solidjs/router'
import { createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { useSingleChat } from '../state/singleChat'

export default function Discussion() {
  const params = useParams()
  const { currentChannelId } = useService(useSingleChat)()
  const { setActiveChannelId, setFocusMessageId } = useService(useChannel)()

  createEffect(() => {
    setActiveChannelId(currentChannelId())
    setFocusMessageId(params.messageId)
  })

  return (
    <GenericChat
      height="calc(100vh - 165px)"
    />
  )
}
